import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=6ef1fd19&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=6ef1fd19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1fd19",
  null
  
)

export default component.exports